import React from "react";

import FilterChips, { Filter } from "../../../../../../../components/FilterChips/FilterChips";

import { AllReviewsFilters, Reviews360Options, StatusSelectionOptions } from "../AllReviewsFilters";

const convertFiltersToReadableList = (filters?: AllReviewsFilters) => {
	const readableList: Filter[] = [];

	if (!filters) return readableList;

	Object.keys(filters).forEach((filterKey) => {
		const filter = filters[filterKey];

		if (filterKey === "employee") {
			readableList.push({
				id: "employee",
				type: "single-employee",
				label: "Employee",
				value: { name: filter.name, id: filter.id },
			});
		}

		if (filterKey === "status") {
			const statusLabels = filter
				.map((statusValue) => StatusSelectionOptions.find((opt) => opt.value === statusValue)?.label)
				.filter(Boolean)
				.join(", ");
			readableList.push({
				id: "status",
				type: "string",
				label: "Status",
				value: statusLabels,
			});
		}

		if (filterKey === "reviews360") {
			const review360Label = Reviews360Options.find((opt) => opt.value === filter)?.label || filter;
			readableList.push({
				id: "reviews360",
				type: "string",
				label: "360 Reviews",
				value: review360Label,
			});
		}
	});
	return readableList;
};

type AllReviewsReadableFiltersListProps = {
	filters: AllReviewsFilters;
	setFilters: (newFilters) => void;
};

const AllReviewsReadableFiltersList = ({ filters, setFilters }: AllReviewsReadableFiltersListProps) => {
	const convertedFilters = convertFiltersToReadableList(filters);

	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<div>
			<FilterChips
				filters={convertedFilters}
				label="Filters applied: "
				onDeleteFilter={(id) => {
					const currentFilters = { ...filters };
					delete currentFilters[id];

					setFilters({ ...currentFilters });
				}}
			/>
		</div>
	);
};

export default AllReviewsReadableFiltersList;
